/**
 * Waarom een kaart op het beginscherm wegblijft, en waarom dat niet hetzelfde is als een fout.
 *
 * De kaarten van `melden`, `formulieren` en `checklists` verschijnen alleen als er iets te doen
 * is. Drie dingen laten zo'n kaart verdwijnen, en twee ervan zijn normaal: de module staat uit
 * (`404`) of de medewerker heeft het recht niet (`403`). De derde is een storing, en die hoort
 * **niet** op dezelfde manier te eindigen.
 *
 * Dat onderscheid is geen netheid. Een `queryFn` die bij elke fout een lege lijst teruggeeft,
 * levert React Query een gelukt antwoord: de uitkomst wordt bewaard en nooit opnieuw opgevraagd.
 * Eén haperend verzoek maakt de kaart dan voor de rest van de sessie onzichtbaar, zonder dat
 * iemand iets te zien krijgt. Zo bleef een ontbrekend recht in stapel 3 een kwartier lang een
 * raadsel: de keuzelijst was leeg en de server had netjes `403` geantwoord.
 *
 * Dus: bij `403` en `404` een lege lijst, en bij al het andere gooien — dan vraagt React Query
 * het opnieuw en ziet de medewerker dat er iets mis is.
 */
export function absentOrThrow(response: Response, error: unknown): never[] {
  if (response.status === 403 || response.status === 404) return [];
  throw error ?? new Error(`Ophalen mislukt (${response.status})`);
}
